import { zendeskAPI } from '../config/routes'
import { BackendCategory, BackendSection } from '../types/entities'
import { fetchData } from '../utils'
import { QueryKeys } from './queryKeys'

interface SectionsResponse {
  sections: BackendSection[]
  categories: [BackendCategory]
}

const fetchSections = async (id: string) => {
  const url = zendeskAPI.categorySections(id)
  const json = await fetchData(url)

  if (json.error) {
    throw new Error(json.error)
  }

  return json
}

const sectionsQueryData = {
  key: QueryKeys.SECTIONS,
  fetch: fetchSections,
}

export { fetchSections, sectionsQueryData }
export type { SectionsResponse }
